import SpeechBubbleIconPath from "@ingka/ssr-icon/paths/speech-bubble";

export default SpeechBubbleIconPath;
